import { type FileId, fileId as fileIdSchema } from "@inrev/common";
import { Option } from "@inrev/core";

/** Rides on each tracked control, so Amplitude reports the file as the `file-id` element attribute. */
export type FileTracking = { "data-amp-track-file-id": FileId };

/**
 * The API stores every file as `<directory>/<file id>.<extension>` and signs that object's path,
 * so a signed URL names the file on screen whichever endpoint handed it out.
 */
export const fileIdFromSignedUrl = (url: string): Option<FileId> => {
	const path = url.split("?")[0] ?? "";
	const objectName = path.slice(path.lastIndexOf("/") + 1);
	return fileIdSchema.safeParse(objectName.split(".")[0]).data;
};

export const toFileTracking = (fileId: Option<FileId>): Option<FileTracking> =>
	Option.map(fileId, (id) => ({ "data-amp-track-file-id": id }));
